import { alpha } from "@mui/material";
import { Coordinate } from "./models/Mapkit";

export const AppConstants = {
    MaxImageBytes: 2097152, // 2MB,
    AllCategoriesValue: "all"
};

// Currently set to Honolulu for pilot.
export const DEFAULT_MAP_LOCATION: Coordinate = {
    latitude: 21.3279535,
    longitude: -157.9638851,
};

export const BeaconViewMode = {
    List: 'list',
    Calendar: 'calendar',
    Map: 'map',
    Card: 'card',
    Archived: 'archived',
    Analytics: 'analytics',
    Editor: 'editor'
};

export const DesignViewMode = {
    Category: 'category',
    QrCode: 'qrcode',
    LandingPage: 'landingpage',
};

export const ModerationViewMode = {
    List: 'list',
    Map: 'map',
    Report: 'report',
};

export const CreatingBeaconViewMode = {
    Beacon: 'beacon',
    Placement: 'placement',
    Schedule: 'schedule',
    Style: 'style',
    Share: 'share'
};

export const ModerationReportViewMode = {
    Queue: 'queue',
    History: 'history'
};

export const AppColor = {
    baseOrange: "#FF671F",
    orangeBackground: alpha("#FF671F", 0.1),
    orangeBoldBackground: alpha("#FF671F", 0.4),
    skeletonBase: "#e3e3e3",
    skeletonHighlight: "#b8b8b8",
    subHeaderText: "#808080",
    headerText: "#333333",
    componentBackground: "#F6F6F6",
    greyUI: "#a0a0a0",
    darkBrand: "#5B5B5B",
    redError: "#d32f2f"
};

export enum Fonts {
    LIGHT = '300',
    REGULAR = '400',
    MEDIUM = '500',
    SEMI_BOLD = '600',
    BOLD = '700',
}
